import { DocumentUploadScreen } from '@/modules/onboarding/identity/document-upload';
import React from 'react';

export default function DocumentUpload() {
    return <DocumentUploadScreen />;
}
